import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import defaultStyles from './MessageDecorate.scss';

const cx = classNames.bind(defaultStyles);

function MessageDecorate({ children, timestamp, reverse, color = 'default', styles = {} }) {
    return (
        <div className={cx('root', color, { reverse }, styles.root)}>
            <div className={cx('message', styles.message)}>
                {children}
                <span className={cx('timestamp', styles.timestamp)}>{timestamp.format('HH:mm')}</span>
            </div>
        </div>
    );
}

MessageDecorate.propTypes = {
    color: PropTypes.oneOf(['default', 'secondary', 'warning']),
    timestamp: PropTypes.object.isRequired,
    styles: PropTypes.shape({
        root: PropTypes.string,
        message: PropTypes.string,
        timestamp: PropTypes.string,
    }),
    reverse: PropTypes.bool,
};

export default memo(MessageDecorate);
